export default __webpack_public_path__ + "angle-pointing-to-left.png";